import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const WorkspaceRedirection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [location.pathname, navigate]);

  return null;
};

export default WorkspaceRedirection;
